import dayjs from 'dayjs';
import { atom } from 'recoil';

export const registerFormState = atom({
    key: 'registerForm',
    default: {
        phone_number: null,
        phone_number_format: '',
        phone_dial_code: '',
        phone_country_code: '',
        email: '',
        first_name: '',
        sur_name: '',
        date_of_birth: dayjs().toDate(),
        password: '',
        confirm_password: '',
        gender: 'male',
    },
});
